<template>
  <button
    :class="['t-button', baseClass]"
    :disabled="disabled"
    @click="handleClick"
  >
    <span class="t-label">
      <span :class="['t-icon-spot', iconClass]"></span>
      <span class="t-label-text"><slot></slot></span>
    </span>
  </button>
</template>

<script>
import BaseMixin from './BaseMixin.vue'

export default {
  name: 'ButtonPush',

  mixins: [BaseMixin],

  methods: {
    handleClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>
